import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CheckAuthGuard implements CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise<boolean>((resolve) => {
      if (this.auth.currentUser?.uuid) {
        this.auth.checkUserAuth().subscribe((res) => {
          if (!res.authenticated) {
            this.auth.logoutReason = 401;
            this.auth.clearSession();
            this.router.navigate(['/']).finally(() => false);
            resolve(false);
          }

          resolve(true);
        });
      }
    });
  }
}
